import { Component } from "react";
import Popup from "..";
import RectButton from "../../ui/button/RectButton";
import Input from "../../ui/Input";
import Select from "../../ui/Select";
import Option from "../../ui/Select/Option";

class EditMainAddressPopup extends Component {
    render() {
        return (
            <Popup className="edit-address-popup">                
                <div className="column">
                <h3>Physical Address</h3>
                    <p>We are required to collect your physical location for sales tax purposes</p>
                    <div className="row">
                        <Input placeHolder="4206 Spruce Street" />
                        <Input placeHolder="19104" />
                    </div>
                    <Select>
                        <Option value="1">United States</Option>
                    </Select>
                    <RectButton text="SAVE ADDRESS" />
                </div>
            </Popup>
        )
    }
}

export default EditMainAddressPopup;